import type { ApiReturnMfe } from '@highimpact-frontend/api-types';

const mfeGroupKey = (mfe: ApiReturnMfe): string =>
  `${mfe.plugin_name}\0${mfe.name}\0${mfe.pretty_name}`;

const parseSemver = (
  version: string | null | undefined
): [number, number, number] => {
  const [major = 0, minor = 0, patch = 0] = (version ?? '0.0.0')
    .split('.')
    .map(Number);
  return [major, minor, patch];
};

const compareSemver = (
  a: string | null | undefined,
  b: string | null | undefined
): number => {
  const [aMajor, aMinor, aPatch] = parseSemver(a);
  const [bMajor, bMinor, bPatch] = parseSemver(b);
  if (aMajor !== bMajor) return aMajor - bMajor;
  if (aMinor !== bMinor) return aMinor - bMinor;
  return aPatch - bPatch;
};

export const keepLatestMfeVersions = (mfes: ApiReturnMfe[]): ApiReturnMfe[] => {
  const byGroup = new Map<string, ApiReturnMfe>();
  for (const mfe of mfes) {
    const key = mfeGroupKey(mfe);
    const existing = byGroup.get(key);
    if (!existing || compareSemver(mfe.version, existing.version) > 0) {
      byGroup.set(key, mfe);
    }
  }
  return [...byGroup.values()];
};
